import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowRight, 
  faHome, 
  faBuilding, 
  faInfoCircle, 
  faUtensils,
  faImage,
  faChartBar,
  faStar,
  faServer
} from '@fortawesome/free-solid-svg-icons';

const EditData = () => {
  const navigate = useNavigate();

  const Card = ({ title, path, icon, children, isSubCard = false }) => (
    <div 
      onClick={() => navigate(path)}
      className={`
        w-full
        bg-white 
        rounded-lg 
        shadow-sm 
        hover:shadow-md 
        transition-all 
        duration-200 
        cursor-pointer 
        group
        ${isSubCard ? 'mb-3' : 'mb-6'}
      `}
    >
      <div className="p-6 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <FontAwesomeIcon 
            icon={icon} 
            className={`${isSubCard ? 'text-lg' : 'text-xl'} text-gray-600`} 
          />
          <h2 className={`${isSubCard ? 'text-lg' : 'text-xl'} font-semibold text-gray-800`}>
            {title}
          </h2>
        </div>
        <FontAwesomeIcon 
          icon={faArrowRight} 
          className="text-gray-400 group-hover:text-gray-600 transition-colors duration-200" 
        />
      </div>
    </div>
  );

  return (
    <>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        Edit Website Content
      </h1>

      {/* Business Info Card */}
      <Card 
        title="Business Information" 
        path="/admin/edit-business-info"
        icon={faBuilding}
      />

      {/* Home Section Group */}
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div className="flex items-center space-x-3 mb-6">
          <FontAwesomeIcon icon={faHome} className="text-2xl text-gray-600" />
          <h2 className="text-2xl font-semibold text-gray-800">Home Page Sections</h2>
        </div>
        
        <div className="space-y-3 pl-4">
          <Card 
            title="Hero Section"
            path="/admin/edit-home-hero"
            icon={faHome}
            isSubCard
          />
          
          <Card 
            title="Stats Section"
            path="/admin/edit-home-stats"
            icon={faChartBar}
            isSubCard
          />

          <Card 
            title="Services Section"
            path="/admin/edit-services"
            icon={faServer}
            isSubCard
          />
          
          
          <Card 
            title="Gallery Section"
            path="/admin/edit-home-gallery"
            icon={faImage}
            isSubCard
          />
          
          <Card 
            title="Reviews Section"
            path="/admin/edit-home-reviews"
            icon={faStar}
            isSubCard
          />
        </div>
      </div>

      {/* About Card */}
      <Card 
        title="About Us" 
        path="/admin/edit-about"
        icon={faInfoCircle}
      />

      {/* Catering Card */}
      <Card 
        title="Catering" 
        path="/admin/edit-catering"
        icon={faUtensils}
      />
    </>
  );
};

export default EditData; 